import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";

const NotFound = lazy(() => import("../pages/NotFound"));
const PortfolioPage = lazy(() => import("../pages/portfolio/page"));
const TermsPage = lazy(() => import("../pages/legal/Terms"));
const PrivacyPage = lazy(() => import("../pages/legal/Privacy"));
const RefundPage = lazy(() => import("../pages/legal/Refund"));
const ContactPage = lazy(() => import("../pages/contact/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/refund",
    element: <RefundPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
